<ng-container *transloco="let t">
  <div class="body-style">
    <div class="container">
      <div class="p-fluid p-grid p-mt-1">
        <div class="p-col-9 p-md-9">
          <h2 class="text-header-upload" id="divApplicationStatusValue">
            {{ selectedData?.application?.statusDesc }}
          </h2>
          <p class="text-prepare-upload" id="divApplicationStatusNotification">
            {{ selectedData?.application?.statusRemark }}
          </p>
        </div>
        <div class="p-col-3 p-md-3 p-mt-2">
          <img
            class="doc-upload"
            src="assets/images/doc-checking.png"
            alt="doc-checking"
            width="82"
          />
        </div>
      </div>

      <div>
        <div class="card" style="padding-top: 20px">
          <div class="p-fluid p-grid align-top-left">
            <div
              class="p-col-12 p-md-12"
              style="margin-top: -15px; margin-bottom: -25px"
            >
              <p
                class="text-header-detail-upload-product-name"
                id="divApplicationStatusProductNameValue"
              >
                {{ selectedData?.application?.productName }}
              </p>
            </div>
            <div class="p-col-12 p-md-12 p-pl-4">
              <span
                class="text-view-upload"
                id="divApplicationStatusDateText"
                >{{ t('appStatus.applicationDate') }}</span
              >
              <span
                class="text-time-extend-upload"
                style="font-size: 14px"
                id="divApplicationStatusDateValue"
              >
                {{
                  selectedData?.application?.submitDate
                    | customThDate: 'dd MMM yyyy':getCurrentLang
                }}
                -
                {{
                  selectedData?.application?.submitDate | date: 'HH:mm'
                }}</span
              >
            </div>

            <div
              class="p-col-4 p-md-4 p-pl-4"
              style="padding-bottom: 0rem"
              id="divApplicationStatusFullNameText"
            >
              <span class="text-view-upload">{{
                t('appStatus.fullName')
              }}</span>
            </div>
            <div
              class="p-col-8 p-md-8 align-left"
              style="padding-bottom: 0rem"
              id="divApplicationStatusFullNameValue"
            >
              <span class="text-time-extend-upload fullname-dynamic">
                <span class="first-name">{{
                  selectedData?.customer?.firstNameTh
                }}</span>
                <span class="last-name"
                  >&nbsp;{{ selectedData?.customer?.lastNameTh }}</span
                >
              </span>

              <!-- <span class="text-time-extend-upload">
                {{ selectedData?.customer?.fullNameTh }}</span
              > -->
            </div>
            <div class="p-col-12 p-md-12 p-mt-2 p-mb-2">
              <div class="info-section-line"></div>
            </div>
          </div>
          <div class="p-fluid p-grid align-top-left">
            <div class="p-col-6 p-md-6 p-pl-4" style="padding-bottom: 0rem">
              <span class="text-view-upload">{{
                t('appStatus.requestLoanAmount')
              }}</span>
            </div>
            <div
              class="p-col-6 p-md-6 p-pl-4 align-left"
              style="padding-bottom: 0rem; color: #015af5"
              id="divApplicationStatusLoanAmountValue"
            >
              <p
                class="text-time-extend-upload"
                style="font-size: 18px; margin-bottom: 0px"
              >
                {{
                  parseToDecimal(selectedData?.application?.requestCreditLimit)
                }}
                <span
                  *ngIf="getCurrentLang === 'th'"
                  style="font-weight: 400; font-size: 16px"
                >
                  บาท
                </span>
              </p>
            </div>
            <div
              class="p-col-6 p-md-6 p-pl-4"
              style="padding-bottom: 0rem"
              id="divApplicationStatusInterestRateText"
            >
              <span class="text-view-upload">{{
                t('appStatus.interestRate')
              }}</span>
            </div>
            <div
              class="p-col-6 p-md-6 p-pl-4 align-left"
              style="padding-bottom: 0rem"
              id="divApplicationStatusInterestRateValue"
            >
              <span class="text-time-extend-upload"
                >{{ selectedData?.application?.offerMaxInterestRate }}%
                <span *ngIf="getCurrentLang === 'th'"> ต่อปี </span>
              </span>
            </div>
            <div
              class="p-col-6 p-md-6 p-pl-4"
              style="padding-bottom: 0rem; line-height: 21px"
            >
              <span class="text-view-upload">
                {{ t('appStatus.installment') }} <br />
                {{ t('appStatus.estimates') }}</span
              >
            </div>
            <div
              class="p-col-6 p-md-6 p-pl-4 align-left"
              style="padding-bottom: 0rem"
              id="divApplicationStatusInstallementValue"
            >
              <span class="loan-amount fw-normal" style="font-family: 'Anuphan'"
                >{{
                  parseToDecimal(
                    selectedData?.application?.maxInstallmentAmount
                  )
                }}
                <span *ngIf="getCurrentLang === 'th'"> บาท </span>
              </span>
            </div>
            <div
              class="p-col-6 p-md-6 p-pl-4"
              style="padding-bottom: 0rem"
              id="divApplicationStatusPaymentTermText"
            >
              <span class="text-view-upload">{{
                t('appStatus.paymentTerms')
              }}</span>
            </div>
            <div
              class="p-col-6 p-md-6 p-pl-4 align-left"
              style="padding-bottom: 0rem"
              id="divApplicationStatusPaymentTermValue"
            >
              <span class="text-time-extend-upload" style="font-weight: 400">
                {{ selectedData?.application?.selectedPaymentTerm }}
                <span *ngIf="getCurrentLang === 'th'">
                  {{ paymentTermEnum.MONTHS_TH }}
                </span>
              </span>
            </div>
            <div
              class="p-col-12 p-md-12 p-pl-4"
              style="padding-bottom: 0rem; line-height: 21px"
              id="divApplicationStatusDescriptionValue"
            >
              <span
                class="text-view-upload"
                [innerHTML]="t('appStatus.installmentAmountPerMonth')"
              >
                {{ t('appStatus.installmentAmountPerMonth') }}</span
              >
            </div>
            <ng-container *ngIf="showMoreFlag">
              <div class="p-col-12 p-md-12 p-mt-2">
                <div class="info-section-line"></div>
              </div>
              <div
                class="p-col-4 p-md-4 p-pl-4"
                style="padding-bottom: 0rem"
                id="divApplicationStatusFeeText"
              >
                <span class="text-view-upload">{{
                  t('appStatus.feeDoc')
                }}</span>
              </div>
              <div
                class="p-col-8 p-md-8 p-pl-4"
                style="padding-bottom: 0rem; text-align: right"
                id="divApplicationStatusFeeValue"
              >
                <p
                  class="text-time-extend-upload"
                  style="font-weight: 400; margin-bottom: 0px"
                >
                  {{ t('appStatus.feeDescriptionUpload') }}
                </p>
              </div>
              <div
                class="p-col-4 p-md-4 p-pl-4"
                style="padding-bottom: 0rem"
                id="divApplicationStatusRefNoText"
              >
                <span class="text-view-upload">{{ t('appStatus.refNo') }}</span>
              </div>
              <div
                class="p-col-8 p-md-8 p-pl-4"
                style="padding-bottom: 0rem; text-align: right"
                id="divApplicationStatusRefNoValue"
              >
                <span
                  class="text-time-extend-upload"
                  style="font-weight: 400"
                  >{{ selectedData?.application?.applicationRef }}</span
                >
              </div>
            </ng-container>
          </div>

          <div class="info-section-line" style="margin-top: 16px"></div>
          <div
            class="center-align"
            style="padding-top: 20px; padding-bottom: 20px; cursor: pointer"
            (click)="showMore()"
          >
            <span class="center-align text-button-action-view-upload">
              {{ showMoreFlag ? 'ย่อ' : 'ดูเพิ่มเติม' }}
            </span>
            <span class="center-align">
              <img
                *ngIf="!showMoreFlag"
                src="assets/images/icon-down.png"
                alt="down"
                width="24"
              />
              <img
                *ngIf="showMoreFlag"
                src="assets/images/icon-up.png"
                alt="up"
                width="24"
              />
            </span>
          </div>
        </div>
      </div>

      <div class="card p-mt-3 p-pb-1" style="padding-top: 1px">
        <ng-container *ngIf="!isResubmitedDocument; else resubmitBlock">
          <!-- บล็อกสำหรับไม่ใช่ Resubmit -->
          <div>
            <p class="text-header-detail-upload">
              {{ t('pendingUploadDocuments.title') }}
            </p>
            <ul>
              <ng-container
                *ngFor="
                  let document of pendingDocumentsList?.documentType;
                  let i = index
                "
              >
                <li *ngIf="document.doc_require" class="list-item">
                  <img
                    src="assets/images/success-green-icon.png"
                    width="24"
                    style="margin-right: 8px"
                  />
                  {{ document.doc_name }}
                </li>
              </ng-container>
            </ul>
          </div>

          <div *ngIf="documentCountNotRequired > 0" class="p-mt-3 p-pb-3">
            <div class="info-section-line"></div>
            <span class="text-header-detail-upload">
              {{ t('pendingUploadDocuments.titleDocNotRequired') }}
            </span>
            <span
              *ngIf="documentCountRequired >= 5"
              style="float: right; display: flex; align-items: center"
              class="p-pr-3"
              (click)="showMoreDocumentNotRequired()"
            >
              <img
                *ngIf="!showMoreFlagDocumentNotRequired"
                src="assets/images/icon-up.png"
                alt="up"
                width="24"
              />
              <img
                *ngIf="showMoreFlagDocumentNotRequired"
                src="assets/images/icon-down.png"
                alt="down"
                width="24"
              />
            </span>

            <ul *ngIf="!showMoreFlagDocumentNotRequired" class="p-mb-0">
              <ng-container
                *ngFor="
                  let document of pendingDocumentsList?.documentType;
                  let i = index
                "
              >
                <li *ngIf="!document.doc_require" class="list-item">
                  <img
                    src="assets/images/success-green-icon.png"
                    width="24"
                    style="margin-right: 8px"
                  />
                  {{ document.doc_name }}
                </li>
              </ng-container>
            </ul>
          </div>
        </ng-container>
        <!-- บล็อกกรณี isResubmitDocument -->
        <ng-template #resubmitBlock>
          <div>
            <p class="text-header-detail-upload">
              {{ t('pendingUploadDocuments.title') }}
            </p>
            <ul>
              <ng-container
                *ngFor="let document of pendingDocumentsList?.documentType"
              >
                <li class="list-item">
                  <img
                    src="assets/images/success-green-icon.png"
                    width="24"
                    style="margin-right: 8px"
                  />
                  {{ document.doc_name }}
                </li>
              </ng-container>
            </ul>
          </div>
        </ng-template>
      </div>
      <div class="p-mb-4" id="divApplicationStatusDescriptionValue">
        <h4 class="p-mb-2 p-mt-3 alert-info">
          <span>{{ t('appStatus.notifyConsiderDialog') }}</span>
          <span style="font-weight: 600 !important">{{
            selectedData?.customer?.email
          }}</span>
        </h4>
      </div>
    </div>
    <div class="button-container">
      <div class="p-mb-3 go-home-btn">
        <web-di-ld-button
          [borderradius]="'48px'"
          [background]="'#015AF5'"
          [fontFamily]="'Anuphan'"
          [label]="'เสร็จสิ้น'"
          (clickEvt)="goToHome()"
          id="btnNcbConsent"
        ></web-di-ld-button>
      </div>
    </div>
  </div>
</ng-container>

<!-- 
<div class="container">
  <ng-container *transloco="let t">
    <div class="p-d-flex p-ai-center p-jc-center p-d-flex-col">
      <img src="assets/images/app-detail-pending.png" alt="" width="210px" />
      <h3 class="p-mb-0 p-mt-3" id="divApplicationStatusValue">
        {{ selectedData?.application?.statusDesc }}
      </h3>
      <p
        class="information-message p-mt-1 p-text-center"
        id="divApplicationStatusNotification"
      >
        {{ selectedData?.application?.statusRemark }}
      </p>
    </div>
    <div class="app-details">
      <div class="info-section-line p-mb-3"></div>
      <div class="p-grid p-grid-card">
        <div
          class="p-col-4 info-label first-col"
          id="divApplicationStatusProductNameText"
        >
          {{ t('appStatus.product') }}
        </div>
        <div
          class="p-col-8 info-value first-col"
          id="divApplicationStatusProductNameValue"
        >
          {{ selectedData?.application?.productName }}
        </div>
        <div class="p-col-4 info-label" id="divApplicationStatusFullNameText">
          {{ t('appStatus.fullName') }}
        </div>
        <div class="p-col-8 info-value" id="divApplicationStatusFullNameValue">
          <span *ngIf="getCurrentLang === 'th'">{{
            selectedData?.customer?.fullNameTh
          }}</span>
          <span *ngIf="getCurrentLang === 'en'">{{
            selectedData?.customer?.fullNameTh
          }}</span>
        </div>
      </div>
      <div class="info-section-line margin-line"></div>

      <div class="p-grid p-grid-card">
        <div class="p-col-6 info-label" id="divApplicationStatusLoanAmountText">
          {{ t('appStatus.loanAmount') }}
        </div>
        <div
          class="p-col-6 info-value"
          id="divApplicationStatusLoanAmountValue"
        >
          <span class="loan-amount">{{
            parseToDecimal(selectedData?.application?.requestCreditLimit)
          }}</span>
          <span *ngIf="getCurrentLang === 'th'"> บาท </span>
          <span *ngIf="getCurrentLang === 'en'"> THB </span>
        </div>
        <div
          class="p-col-6 info-label"
          id="divApplicationStatusInterestRateText"
        >
          {{ t('appStatus.interestRate') }}
        </div>
        <div
          class="p-col-6 info-value loan-interest"
          id="divApplicationStatusInterestRateValue"
        >
          {{ selectedData?.application?.offerMaxInterestRate }}%
          <span *ngIf="getCurrentLang === 'th'"> ต่อปี </span>
          <span *ngIf="getCurrentLang === 'en'"> per year </span>
        </div>

        <div
          class="p-col-6 info-label"
          id="divApplicationStatusInstallementText"
        >
          {{ t('appStatus.estimatesMonthlyInstallment') }}
        </div>
        <div
          class="p-col-6 info-value"
          id="divApplicationStatusInstallementValue"
        >
          <span class="loan-amount">{{
            parseToDecimal(selectedData?.application?.maxInstallmentAmount)
          }}</span>
          <span *ngIf="getCurrentLang === 'th'"> บาท </span>
          <span *ngIf="getCurrentLang === 'en'"> THB </span>
        </div>

        <div
          class="p-col-6 info-label"
          id="divApplicationStatusPaymentTermText"
        >
          {{ t('appStatus.paymentTerms') }}
        </div>
        <div
          class="p-col-6 info-value"
          id="divApplicationStatusPaymentTermValue"
        >
          {{ selectedData?.application?.selectedPaymentTerm }}
          <span
            *ngIf="selectedData?.application?.selectedPaymentTermType === 'M'"
          >
            <span *ngIf="getCurrentLang === 'th'">
              {{ paymentTermEnum.MONTHS_TH }}
            </span>
            <span *ngIf="getCurrentLang === 'en'">
              {{ paymentTermEnum.MONTHS_EN }}
            </span>
          </span>
        </div>
        <div
          class="p-col-12 info-label p-pb-0 p-mb-3"
          id="divApplicationStatusDescriptionValue"
        >
          <div class="p-d-flex info-label-color">
            <div class="info-start mt-0">
              <i class="pi pi-info-circle i-style"></i>
            </div>
            <div class="p-ml-2">
              {{ t('appStatus.installmentAmountPerMonth') }}
            </div>
          </div>
        </div>
      </div>
      <div class="info-section-line"></div>
      <div *ngIf="isCollapse">
        <div class="p-grid p-grid-card">
          <div
            class="p-col-6 info-label p-my-3 p-py-0"
            id="divApplicationStatusFeeText"
          >
            {{ t('appStatus.fee') }}
          </div>
          <div
            class="p-col-6 info-value p-my-3 p-py-0"
            id="divApplicationStatusFeeValue"
          >
            {{ t('appStatus.percent') }}<br />
            {{ t('appStatus.feeDescription') }}
          </div>
        </div>
        <div class="info-section-line"></div>
        <div class="p-grid p-grid-card">
          <div
            class="p-col-6 info-label p-pt-0 p-mt-3"
            id="divApplicationStatusDateText"
          >
            {{ t('appStatus.applicationDate') }}
          </div>
          <div
            class="p-col-6 info-value p-pt-0 p-mt-3"
            id="divApplicationStatusDateValue"
          >
            {{
              selectedData?.application?.submitDate
                | customThDate: 'd MMM yy':getCurrentLang
            }}
            {{ selectedData?.application?.submitDate | date: 'HH:mm' }}
          </div>
          <div class="p-col-12 p-mb-3">
            <div class="p-d-flex p-jc-between">
              <div class="info-label p-pb-0" id="divApplicationStatusRefNoText">
                {{ t('appStatus.refNo') }}
              </div>
              <div
                class="info-value p-pb-0"
                id="divApplicationStatusRefNoValue"
              >
                {{ selectedData?.application?.applicationRef }}
              </div>
            </div>
          </div>
        </div>
        <div class="info-section-line"></div>
      </div>
      <div class="button-link p-mt-2">
        <p-button
          (click)="toggleDocList()"
          *ngIf="!isCollapse"
          icon="pi pi-angle-down"
          iconPos="right"
          label="{{ t('applyConfirmationInfo.seeMore') }}"
          styleClass="p-button-link p-mb-0  fix-position fw-bold"
        >
        </p-button>
        <p-button
          (click)="toggleDocList()"
          *ngIf="isCollapse"
          icon="pi pi-angle-up"
          iconPos="right"
          label="{{ t('applyConfirmationInfo.short') }}"
          styleClass="p-button-link p-mb-0 fix-position fw-bold"
        >
        </p-button>
      </div>
      <div class="info-gray-card p-p-3 p-mt-2">
        <h4 class="text-h4">
          {{ t('pendingUploadDocuments.title') }}
        </h4>
        <ul class="documents-list">
          <li
            *ngFor="
              let document of pendingDocumentsList?.documentType;
              let i = index
            "
            class="list-item"
          >
            {{ document.doc_name }}
          </li>
        </ul>
      </div>
      <div class="p-grid p-grid-card info-alert-card p-mt-3 p-mb-4">
        <div
          class="p-col-12 info-label"
          id="divApplicationStatusDescriptionValue"
        >
          <div class="p-d-flex info-alert-text">
            <div class="info-start">
              <i class="pi pi-info-circle"></i>
            </div>
            <div class="p-ml-2">
              {{
                t('appStatus.notifyConsiderDialog', {
                  email: selectedData?.customer?.email
                })
              }}
            </div>
          </div>
        </div>
      </div>
      <div class="p-mb-3">
        <web-di-ld-button
          #nextButton
          id="btnNcbConsent"
          refId="BtnNcbConsent"
          label="{{ t('applySuccess.backTo') }}"
          [type]="'button'"
          (clickEvt)="back()"
        ></web-di-ld-button>
      </div>
    </div>
  </ng-container>
</div> -->
